<script setup lang="ts">
import { computed } from "vue";
import useDialog from "@/ui/composables/useDialog";

const dialog = useDialog();

async function resolveDialog(value?: unknown) {
	switch (dialog.current?.type) {
		case "alert": {
			dialog.current?.resolve();
			break;
		}
		case "confirm": {
			dialog.current?.resolve(Boolean(value));
			break;
		}
		default:
			break;
	}

	dialog.current = null;
}

const isOpen = computed(() => dialog.current !== null);
const isConfirm = computed(() => dialog.current?.type === "confirm");
</script>

<!--
	HACK: The v-if is more so optional, it avoids some ugly where the
	dialog is set to null and animates away.

	What this causes is the dialog to suddenly be empty and then animate
	away. With v-if we avoid that ugly thing.
-->
<template>
	<v-dialog v-if="isOpen" v-model="isOpen" max-width="500">
		<v-card elevation="9" class="help">
			<v-toolbar flat>
				<v-toolbar-title>
					{{ dialog.current.title }}
				</v-toolbar-title>
			</v-toolbar>

			<v-card-text>
				<p style="white-space: pre-wrap">{{ dialog.current.message }}</p>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-btn
					v-if="isConfirm"
					:color="dialog.current.isDelete ? 'primary' : 'red'"
					@click="resolveDialog(false)"
				>
					{{ dialog.current.cancelButtonText || "Cancel" }}
				</v-btn>

				<v-btn
					:variant="dialog.current.isDelete ? 'tonal' : 'flat'"
					:color="dialog.current.isDelete ? 'red' : 'secondary'"
					@click="resolveDialog(isConfirm ? true : undefined)"
				>
					{{ isConfirm ? dialog.current.confirmButtonText : "Ok" }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
